module.exports = __webpack_public_path__ + "files/75dfb21f0765894cc80a6fa6812ecd9f.png";